import {API_ROOT_URL} from 'envs/_current/config'
import _ from 'lodash'
import {normalize, schema} from 'normalizr'
import {emptyObject} from '../helpers/emptyObjects'
import {baseFieldTypes} from './base/baseFieldTypes'
import {eventSchema} from './schema/event'
import {createListTransform} from './utils/createListTransform'
import {createTransform} from './utils/createTransform'

const transform = createTransform(eventSchema, 'data')

const transformArray = createListTransform(eventSchema)

const fields = [
    'user_id', // auto fill = creator
    'owner_id', // user or organization
    'owner_type', // user or organization
    'categories', // user or organization
    'title', // required|max:100
    'description', //max:10000
    'idname', // unique:events,idname
    'status', // -1, 1, 9
    'active', // 0 / 1
    'privacy', // 1 / 2
    'public', // 0 / 1
]

const fieldTypes = {
    user_id: baseFieldTypes.auto,
    owner_id: baseFieldTypes.string,
    owner_type: baseFieldTypes.string,
    idname: baseFieldTypes.string,
}

// Route::post('events/add', 'EventController@store');
export const event_add_Api = {
    backend: `Route::post('events/add', 'EventController@store');`,
    root: API_ROOT_URL,
    path: '/events/add',
    method: 'POST',
    fields: ['owner_id', 'owner_type'],
    fieldTypes,
    transform: (response, {values = {}}) => {
        let error, errorMessages, entities, result, success
        const {status} = response || emptyObject
        const data = _.get(response, 'data')
        const {owner_id, owner_type} = values
        switch (status) {
            case 200:
                success = true
                const {entities: e, result: r} = normalize(
                    data,
                    new schema.Entity(
                        'organizations',
                        {},
                        {
                            idAttribute: () => owner_id,
                            processStrategy: (entities) => {
                                return {
                                    idname: owner_id,
                                    events: [data],
                                }
                            },
                        }
                    )
                )
                entities = e
                result = r
                break

            default:
                error = true
                errorMessages = response.data
                break
        }

        return {
            ...response,
            response,
            error,
            errorMessages,
            success,
            status,
            entities,
            result,
        }
    },
}

export const event_edit_Api = {
    backend: `Route::post('events/{id}/edit', 'EventController@update');`,
    root: API_ROOT_URL,
    path: '/events/:id/edit',
    method: 'POST',
    fields,
    fieldTypes,
    transform: createTransform(eventSchema, 'data'),
}

export const event_delete_Api = {
    backend: ` Route::post('events/{id}/delete', 'EventController@delete');`,
    root: API_ROOT_URL,
    path: '/events/:id/delete',
    method: 'POST',
    fields,
    fieldTypes,
    transform,
}

export const event_claimReward_Api = {
    backend: `Route::post('events/{id}/claim-reward', 'EventController@claimReward');`,
    root: API_ROOT_URL,
    path: '/events/:id/claim-reward',
    method: 'POST',
    fields,
    fieldTypes,
    transform: createTransform(eventSchema, 'data'),
}


// Route::get('events/{id}/get', 'EventController@getById');
export const event_getById_Api = {
    backend: `Route::get('events/{id}/get', 'EventController@getById');`,
    root: API_ROOT_URL,
    path: '/events/:id/get',
    method: 'GET',
    fields,
    fieldTypes,
    transform: createTransform(eventSchema, 'data'),
}

export const event_getEventsByProps_Api = {
    backend: `Route::get('events/{type}/{id}/gets', 'EventController@getEventsByProps');`,
    root: API_ROOT_URL,
    path: '/events/:type/:id/gets',
    method: 'GET',
    fields,
    fieldTypes,
    // `hide_expired`: lọc theo đúng công thức is_expired của EventTransformerCompact (status=9 HOẶC
    // time_close đã qua) - chỉ áp dụng khi admin xem (non-admin backend đã tự ẩn sự kiện hết hạn sẵn).
    paramsFields: ['keyword', 'sort_by', 'hide_expired'],
    transform: transformArray,
    schema: eventSchema,
}

export const event_getUpcomingEventsByProps_Api = {
    backend: `Route::get('events/{type}/{id}/get-upcoming-items', 'EventController@getUpcomingEventsByProps');`,
    root: API_ROOT_URL,
    path: '/events/:type/:id/get-upcoming-items',
    method: 'GET',
    fields,
    fieldTypes,
    paramsFields: ['keyword', 'sort_by'],
    transform: transformArray,
    schema: eventSchema,
}

export const event_getIncomingEvents_Api = {
    backend: `Route::get('events/fetch-incoming-items', 'EventController@getIncomingEvents');`,
    root: API_ROOT_URL,
    path: '/events/fetch-incoming-items',
    method: 'GET',
    fields,
    fieldTypes,
    paramsFields: ['keyword', 'sort_by'],
    transform: transformArray,
    schema: eventSchema,
}

// Route::get('events/category/{category_id}/gets', 'EventController@getEventsByCategory');
export const event_getEventsByCategory_Api = {
    backend: ``,
    root: API_ROOT_URL,
    path: '/events/category/:category_id/gets',
    method: 'GET',
    paramsFields: ['exclude_promos'],
    transform: transformArray,
    schema: eventSchema,
}

export const event_getEventsByFollowingCategory_Api = {
    backend: `Route::get('events/get-by-following-categories', 'EventController@getEventsByFollowingCategory');`,
    root: API_ROOT_URL,
    path: '/events/get-by-following-categories',
    method: 'GET',
    schema: eventSchema,
    paramsFields: ['categories', 'languages'],
    transform: createListTransform(eventSchema),
}


export const eventLocationSchema = new schema.Entity(
    'event_locations',
    {},
    {
        idAttribute: 'id',
    }
)


export const event_location_getById_Api = {
    backend: `Route::get('event-locations/{id}/get', 'EventLocationController@getById');`,
    root: API_ROOT_URL,
    path: '/event-locations/:id/get',
    method: 'GET',
    schema: eventLocationSchema,
    transform: createTransform(eventLocationSchema, 'data'),
}


export const event_location_getEventLocations_Api = {
    backend: `Route::get('events/{event_id}/event-locations/gets', 'EventLocationController@getEventLocations');`,
    root: API_ROOT_URL,
    path: '/events/:id/event-locations/gets',
    method: 'GET',
    paramsFields: ['sort_by', 'public', 'active', 'keyword',
        'religious_order_group', 'target_gender', 'country_id', 'diocese_id', 'authority_typecd', 'nature_typecd'],
    schema: eventLocationSchema,
    transform: createListTransform(eventLocationSchema),
}


export const event_location_getCoordinateEventLocations_Api = {
    backend: `Route::get('events/{event_id}/event-locations/get-coordinates', 'EventLocationController@getCoordinateEventLocations');`,
    root: API_ROOT_URL,
    path: '/events/:id/event-locations/get-coordinates',
    method: 'GET',
    paramsFields: ['sort_by', 'public', 'active', 'keyword',
        'religious_order_group', 'target_gender', 'country_id', 'diocese_id', 'authority_typecd', 'nature_typecd'],
    schema: eventLocationSchema,
    transform: createListTransform(eventLocationSchema),
}

export const event_location_createEventLocation_Api = {
    backend: `Route::post('events/{event_id}/event-locations/add', 'EventLocationController@createEventLocation');`,
    root: API_ROOT_URL,
    path: '/events/:id/event-locations/add',
    method: 'POST',
    paramsFields: [],
    schema: eventLocationSchema,
    transform: createTransform(eventLocationSchema, 'data'),
}

export const event_location_updateEventLocation_Api = {
    backend: `Route::post('event-locations/{id}/edit', 'EventLocationController@updateEventLocation');`,
    root: API_ROOT_URL,
    path: '/event-locations/:id/edit',
    method: 'POST',
    paramsFields: [],
    schema: eventLocationSchema,
    transform: createTransform(eventLocationSchema, 'data'),
}

export const event_location_deleteEventLocation_Api = {
    backend: `Route::post('event-locations/{id}/delete', 'EventLocationController@deleteEventLocation');`,
    root: API_ROOT_URL,
    path: '/event-locations/:id/delete',
    method: 'POST',
    paramsFields: [],
    schema: eventLocationSchema,
    transform: createTransform(eventLocationSchema, 'data'),
}
export const event_location_resetSecretKey_Api = {
    backend: `Route::post('event-locations/{id}/renew-secret-key', 'EventLocationController@resetSecretKey');`,
    root: API_ROOT_URL,
    path: '/event-locations/:id/renew-secret-key',
    method: 'POST',
    paramsFields: [],
    schema: eventLocationSchema,
    transform: createTransform(eventLocationSchema, 'data'),
}


export const eventCheckinSchema = new schema.Entity(
    'event_checkins',
    {},
    {
        idAttribute: 'id',
    }
)
export const event_checkin_userCheckin_Api = {
    backend: `Route::post('events/{event_id}/locations/{event_location_id}/checkin', 'EventCheckinController@userCheckin');`,
    root: API_ROOT_URL,
    path: '/events/:id/locations/:event_location_id/checkin',
    method: 'POST',
    paramsFields: [],
    schema: eventCheckinSchema,
    transform: createTransform(eventCheckinSchema, 'data'),
}
export const event_checkin_adminAddCheckin_Api = {
    backend: `Route::post('events/{event_id}/locations/{event_location_id}/admin-add-checkin', 'EventCheckinController@adminAddCheckin');`,
    root: API_ROOT_URL,
    path: '/events/:id/locations/:event_location_id/admin-add-checkin',
    method: 'POST',
    paramsFields: [],
    schema: eventCheckinSchema,
    transform: createTransform(eventCheckinSchema, 'data'),
}
export const event_checkin_removeCheckin_Api = {
    backend: `Route::post('event-checkins/{checkin_id}/remove', 'EventCheckinController@removeCheckin');`,
    root: API_ROOT_URL,
    path: '/event-checkins/:checkin_id/remove',
    method: 'POST',
    paramsFields: [],
    schema: eventCheckinSchema,
    transform: createTransform(eventCheckinSchema, 'data'),
}

export const event_checkin_getCheckinsByEvent_Api = {
    backend: `Route::get('/events/{event_id}/checkins', 'EventCheckinController@getCheckinsByEvent');`,
    root: API_ROOT_URL,
    path: '/events/:event_id/checkins',
    method: 'GET',
    paramsFields: [],
    schema: eventCheckinSchema,
    transform: createListTransform(eventCheckinSchema),
}

export const event_checkin_getByEventLocationId_Api = {
    backend: `Route::get('/event-locations/{event_location_id}/checkins', 'EventCheckinController@getByEventLocationId');`,
    root: API_ROOT_URL,
    path: '/event-locations/:event_location_id/checkins',
    method: 'GET',
    paramsFields: [],
    schema: eventCheckinSchema,
    transform: createListTransform(eventCheckinSchema),
}

export const event_checkin_getMyEventCheckins_Api = {
    backend: ` Route::get('events/my-event-checkins', 'EventCheckinController@getMyEventCheckins');`,
    root: API_ROOT_URL,
    path: '/events/my-event-checkins',
    method: 'GET',
    paramsFields: [],
    schema: eventCheckinSchema,
    transform: createListTransform(eventCheckinSchema),
}

export const event_checkin_getEventCheckinToken_Api = {
    backend: `Route::get('events/{event_id}/locations/{event_location_id}/get-checkin-token', 'EventCheckinController@getEventCheckinToken');`,
    root: API_ROOT_URL,
    path: '/events/:id/locations/:event_location_id/get-checkin-token',
    method: 'GET',
    schema: eventLocationSchema,
    transform: createTransform(eventLocationSchema, 'data'),
}


export const userCheckinSchema = new schema.Entity(
    'user_checkins',
    {},
    {
        idAttribute: 'id',
    }
)
export const user_checkin_userCheckin_Api = {
    backend: `Route::post('checkins/{owner_type}/{owner_id}/checkin', 'EventCheckinController@userCheckin');`,
    root: API_ROOT_URL,
    path: '/checkins/:owner_type/:owner_id/checkin',
    method: 'POST',
    paramsFields: [],
    schema: userCheckinSchema,
    transform: createTransform(userCheckinSchema, 'data'),
}
export const user_checkin_userCheckinSaveOnly_Api = {
    backend: `Route::post('checkins/{owner_type}/{owner_id}/save', 'EventCheckinController@userCheckinSaveOnly');`,
    root: API_ROOT_URL,
    path: '/checkins/:owner_type/:owner_id/save',
    method: 'POST',
    paramsFields: [],
    schema: userCheckinSchema,
    transform: createTransform(userCheckinSchema, 'data'),
}

export const user_checkin_removeUserCheckin_Api = {
    backend: `Route::post('checkins/{id}/remove-checkin', 'EventCheckinController@removeUserCheckin');`,
    root: API_ROOT_URL,
    path: '/checkins/:id/remove-checkin',
    method: 'POST',
    paramsFields: [],
    schema: userCheckinSchema,
    transform: createTransform(userCheckinSchema, 'data'),
}

export const user_checkin_editUserCheckin_Api = {
    backend: `Route::post('checkins/{id}/edit-checkin', 'EventCheckinController@editUserCheckin');`,
    root: API_ROOT_URL,
    path: '/checkins/:id/edit-checkin',
    method: 'POST',
    paramsFields: [],
    schema: userCheckinSchema,
    transform: createTransform(userCheckinSchema, 'data'),
}


export const user_checkin_getMyCheckins_Api = {
    backend: `Route::get('checkins/my-checkins', 'EventCheckinController@getMyCheckins');`,
    root: API_ROOT_URL,
    path: '/checkins/my-checkins',
    method: 'GET',
    paramsFields: ['type'],
    schema: userCheckinSchema,
    transform: createListTransform(userCheckinSchema),
}


export const user_checkin_getMyCheckinsByOwner_Api = {
    backend: `Route::get('checkins/{owner_type}/{owner_id}/gets-by-owner', 'EventCheckinController@getMyCheckinsByOwner');`,
    root: API_ROOT_URL,
    path: '/checkins/:owner_type/:owner_id/gets-by-owner',
    method: 'GET',
    paramsFields: [],
    schema: userCheckinSchema,
    transform: createListTransform(userCheckinSchema),
}


export const event_getPilgrimageEventInfo_Api = {
    backend: `Route::get('events/get-pilgrimage-event-info', 'EventController@getPilgrimageEventInfo');`,
    root: API_ROOT_URL,
    path: '/events/get-pilgrimage-event-info',
    method: 'GET',
}